import { z } from 'zod';
export const roleSchema = z.enum(['rider', 'driver', 'admin']);
export const vehicleTypeSchema = z.enum(['bike', 'economy', 'premium']);
export const driverStatusSchema = z.enum(['offline', 'online', 'on_trip']);
export const tripStatusSchema = z.enum([
    'requested',
    'searching',
    'assigned',
    'arriving',
    'arrived',
    'in_progress',
    'completed',
    'cancelled',
]);
export const paymentMethodSchema = z.enum(['cash', 'card']);
export const latLngSchema = z.object({
    lat: z.number().gte(-90).lte(90),
    lng: z.number().gte(-180).lte(180),
});
export const placeSchema = latLngSchema.extend({
    label: z.string().trim().min(1).max(200),
});
const phoneSchema = z
    .string()
    .trim()
    .regex(/^\+?[0-9 -]{7,20}$/, 'Enter a valid phone number.');
const passwordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters.')
    .max(72, 'Password is too long.');
export const registerSchema = z.object({
    name: z.string().trim().min(2).max(80),
    email: z.string().trim().toLowerCase().email(),
    phone: phoneSchema,
    password: passwordSchema,
    role: roleSchema.default('rider'),
});
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: passwordSchema,
});
export const estimateQuerySchema = z.object({
    type: vehicleTypeSchema,
    pickupLat: z.coerce.number().gte(-90).lte(90),
    pickupLng: z.coerce.number().gte(-180).lte(180),
    dropLat: z.coerce.number().gte(-90).lte(90),
    dropLng: z.coerce.number().gte(-180).lte(180),
});
export const requestRideSchema = z.object({
    vehicleType: vehicleTypeSchema,
    pickup: placeSchema,
    drop: placeSchema,
    paymentMethod: paymentMethodSchema,
});
export const cancelTripSchema = z.object({
    reason: z.string().trim().min(1).max(200).optional(),
});
export const rateTripSchema = z.object({
    rating: z.number().int().gte(1).lte(5),
    note: z.string().trim().max(500).optional(),
});
export const driverStatusUpdateSchema = z.object({
    status: z.enum(['online', 'offline']),
});
export const driverLocationSchema = z.object({
    lat: z.number().gte(-90).lte(90),
    lng: z.number().gte(-180).lte(180),
    heading: z.number().gte(0).lt(360).optional(),
});
export const fareConfigSchema = z.object({
    vehicleType: vehicleTypeSchema,
    base: z.number().int().nonnegative(),
    perKm: z.number().int().nonnegative(),
    perMin: z.number().int().nonnegative(),
    minFare: z.number().int().nonnegative(),
});
export const surgeZoneSchema = z.object({
    name: z.string().trim().min(1).max(60),
    multiplier: z.number().gte(1).lte(5),
    active: z.boolean(),
});
//# sourceMappingURL=schemas.js.map